export default __webpack_public_path__ + "static/media/hgi_logo.761dfeb1.png";